module.exports = __webpack_public_path__ + "img/ur3_01.12760f35.jpg";